/* eslint-disable no-param-reassign */
import axios from 'axios';
import { API_URL } from '../constant/url';

const request = axios.create();

let REQUEST_URLS = [];

request.interceptors.request.use(
    (config) => {
        document.body.classList.add('loading-indicator');
        REQUEST_URLS.push(config.url);
        config.baseURL = `${API_URL}`;
        if (localStorage.getItem('token')) {
            config.headers = {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                Accept: 'application/json',
            };
        }
        return config;
    },
    (error) => Promise.reject(error),
);

request.interceptors.response.use(
    (response) => {
        const index = REQUEST_URLS.indexOf(response.config.url);
        if (index > -1) {
            REQUEST_URLS.splice(index, 1);
        }
        if (!REQUEST_URLS.length) {
            document.body.classList.remove('loading-indicator');
        }
        const {data, headers} = response;
        if (data instanceof ArrayBuffer) {
            if (headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                const fileName = headers["content-disposition"].split("filename=")[1].split(";")[0];
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName.replaceAll('"', ''));
                document.body.appendChild(link);
                link.click();
                return '';
            }
            const parsedResponse = JSON.parse(new TextDecoder().decode(data));
            return parsedResponse?.data || '';
        }
        return data;
    },
    (error) => {
        const index = REQUEST_URLS.indexOf(error.config.url);
        if (index > -1) {
            REQUEST_URLS.splice(index, 1);
        }
        if (!REQUEST_URLS.length) {
            document.body.classList.remove('loading-indicator');
        }
        if (error.response) {
            return Promise.reject(error.response.data);
        }
        if (error.request) {
            return Promise.reject(error.request);
        }
        return Promise.reject(error);
    },
);

export default request;
